import React from "react";
import { Link } from "react-router-dom";
import { LOCATION } from "../config/location";
import { PageHead } from "../components/site/Blocks";

import "./styles/datenschutz.css";

const Datenschutz = () => {
    return (
        <>
            <PageHead eyebrow="Rechtliches" title="Datenschutzerklärung" className="!pb-12" />
            <section className="sec pb-[140px]">
            <div className="legal">
                <h2 id="m716">Präambel</h2>
                <p>
                    Mit der folgenden Datenschutzerklärung möchten wir Sie
                    darüber aufklären, welche Arten Ihrer personenbezogenen
                    Daten (nachfolgend auch kurz als "Daten" bezeichnet) wir zu
                    welchen Zwecken und in welchem Umfang verarbeiten. Die
                    Datenschutzerklärung gilt für alle von uns durchgeführten
                    Verarbeitungen personenbezogener Daten, sowohl im Rahmen der
                    Erbringung unserer Leistungen als auch insbesondere auf
                    unseren Webseiten, in mobilen Applikationen sowie innerhalb
                    externer Onlinepräsenzen, wie z. B. unserer
                    Social-Media-Profile (nachfolgend zusammenfassend bezeichnet
                    als "Onlineangebot").
                </p>
                <p>
                    Die verwendeten Begriffe sind nicht geschlechtsspezifisch.
                </p>
                <p>Stand: 13. Oktober 2026</p>
                <h2>Inhaltsübersicht</h2>{" "}
                <ul class="index">
                    <li>
                        <a class="index-link" href="#m716">
                            Präambel
                        </a>
                    </li>
                    <li>
                        <a class="index-link" href="#m3">
                            Verantwortlicher
                        </a>
                    </li>
                    <li>
                        <a class="index-link" href="#mOverview">
                            Übersicht der Verarbeitungen
                        </a>
                    </li>
                    <li>
                        <a class="index-link" href="#m2427">
                            Maßgebliche Rechtsgrundlagen
                        </a>
                    </li>
                    <li>
                        <a class="index-link" href="#m27">
                            Sicherheitsmaßnahmen
                        </a>
                    </li>
                    <li>
                        <a class="index-link" href="#m12">
                            Allgemeine Informationen zur Datenspeicherung und
                            Löschung
                        </a>
                    </li>
                    <li>
                        <a class="index-link" href="#m10">
                            Rechte der betroffenen Personen
                        </a>
                    </li>
                    <li>
                        <a class="index-link" href="#m225">
                            Bereitstellung des Onlineangebots und Webhosting
                        </a>
                    </li>
                    <li>
                        <a class="index-link" href="#m182">
                            Kontakt- und Anfrageverwaltung
                        </a>
                    </li>
                    <li>
                        <a className="index-link" href="#mReservierung">
                            Reservierungen, Bestellungen und Veranstaltungsanfragen
                        </a>
                    </li>
                    <li>
                        <a className="index-link" href="#mTurnstile">
                            Schutz vor Missbrauch (Cloudflare Turnstile)
                        </a>
                    </li>
                    <li>
                        <a className="index-link" href="#mKarte">
                            Kartendarstellung (OpenStreetMap)
                        </a>
                    </li>
                    <li>
                        <a className="index-link" href="#mLinks">
                            Links zu externen Angeboten
                        </a>
                    </li>
                </ul>
                <h2 id="m3">Verantwortlicher</h2>
                <p>
                    Spyros Gkikas
                    <br />
                    Restaurant En Edem
                    <br />
                    {LOCATION.street}
                    <br />
                    76356 Weingarten, Deutschland
                </p>
                <p>Vertretungsberechtigte Personen: Spyros Gkikas</p>
                <p>E-Mail-Adresse: info@en-edem.de</p>
                <p>
                    Impressum:{" "}
                    <Link to="/impressum">https://www.en-edem.de/impressum</Link>
                </p>
                <h2 id="mOverview">Übersicht der Verarbeitungen</h2>
                <p>
                    Die nachfolgende Übersicht fasst die Arten der verarbeiteten
                    Daten und die Zwecke ihrer Verarbeitung zusammen und
                    verweist auf die betroffenen Personen.
                </p>
                <h3>Arten der verarbeiteten Daten</h3>
                <ul>
                    <li>Bestandsdaten.</li>
                    <li>Kontaktdaten.</li>
                    <li>Inhaltsdaten.</li>
                    <li>Nutzungsdaten.</li>
                    <li>Meta-, Kommunikations- und Verfahrensdaten.</li>
                    <li>Protokolldaten.</li>
                </ul>
                <h3>Kategorien betroffener Personen</h3>
                <ul>
                    <li>Kommunikationspartner.</li>
                    <li>Nutzer.</li>
                </ul>
                <h3>Zwecke der Verarbeitung</h3>
                <ul>
                    <li>Kommunikation.</li>
                    <li>Sicherheitsmaßnahmen.</li>
                    <li>Organisations- und Verwaltungsverfahren.</li>
                    <li>Feedback.</li>
                    <li>
                        Bereitstellung unseres Onlineangebotes und
                        Nutzerfreundlichkeit.
                    </li>
                    <li>Informationstechnische Infrastruktur.</li>
                </ul>
                <h2 id="m2427">Maßgebliche Rechtsgrundlagen</h2>
                <p>
                    <strong>
                        Maßgebliche Rechtsgrundlagen nach der DSGVO:{" "}
                    </strong>
                    Im Folgenden erhalten Sie eine Übersicht der
                    Rechtsgrundlagen der DSGVO, auf deren Basis wir
                    personenbezogene Daten verarbeiten. Bitte nehmen Sie zur
                    Kenntnis, dass neben den Regelungen der DSGVO nationale
                    Datenschutzvorgaben in Ihrem bzw. unserem Wohn- oder
                    Sitzland gelten können. Sollten ferner im Einzelfall
                    speziellere Rechtsgrundlagen maßgeblich sein, teilen wir
                    Ihnen diese in der Datenschutzerklärung mit.
                </p>
                <ul>
                    <li>
                        <strong>
                            Vertragserfüllung und vorvertragliche Anfragen (Art.
                            6 Abs. 1 S. 1 lit. b) DSGVO)
                        </strong>{" "}
                        - Die Verarbeitung ist für die Erfüllung eines Vertrags,
                        dessen Vertragspartei die betroffene Person ist, oder
                        zur Durchführung vorvertraglicher Maßnahmen
                        erforderlich, die auf Anfrage der betroffenen Person
                        erfolgen.
                    </li>
                    <li>
                        <strong>
                            Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f)
                            DSGVO)
                        </strong>{" "}
                        - die Verarbeitung ist zur Wahrung der berechtigten
                        Interessen des Verantwortlichen oder eines Dritten
                        notwendig, vorausgesetzt, dass die Interessen,
                        Grundrechte und Grundfreiheiten der betroffenen Person,
                        die den Schutz personenbezogener Daten verlangen, nicht
                        überwiegen.
                    </li>
                </ul>
                <p>
                    <strong>
                        Nationale Datenschutzregelungen in Deutschland:{" "}
                    </strong>
                    Zusätzlich zu den Datenschutzregelungen der DSGVO gelten
                    nationale Regelungen zum Datenschutz in Deutschland. Hierzu
                    gehört insbesondere das Gesetz zum Schutz vor Missbrauch
                    personenbezogener Daten bei der Datenverarbeitung
                    (Bundesdatenschutzgesetz – BDSG). Das BDSG enthält
                    insbesondere Spezialregelungen zum Recht auf Auskunft, zum
                    Recht auf Löschung, zum Widerspruchsrecht, zur Verarbeitung
                    besonderer Kategorien personenbezogener Daten, zur
                    Verarbeitung für andere Zwecke und zur Übermittlung sowie
                    automatisierten Entscheidungsfindung im Einzelfall
                    einschließlich Profiling. Ferner können
                    Landesdatenschutzgesetze der einzelnen Bundesländer zur
                    Anwendung gelangen.
                </p>
                <h2 id="m27">Sicherheitsmaßnahmen</h2>
                <p>
                    Wir treffen nach Maßgabe der gesetzlichen Vorgaben unter
                    Berücksichtigung des Stands der Technik, der
                    Implementierungskosten und der Art, des Umfangs, der
                    Umstände und der Zwecke der Verarbeitung sowie der
                    unterschiedlichen Eintrittswahrscheinlichkeiten und des
                    Ausmaßes der Bedrohung der Rechte und Freiheiten natürlicher
                    Personen geeignete technische und organisatorische
                    Maßnahmen, um ein dem Risiko angemessenes Schutzniveau zu
                    gewährleisten.
                </p>
                <p>
                    Zu den Maßnahmen gehören insbesondere die Sicherung der
                    Vertraulichkeit, Integrität und Verfügbarkeit von Daten
                    durch Kontrolle des physischen und elektronischen Zugangs zu
                    den Daten als auch des sie betreffenden Zugriffs, der
                    Eingabe, der Weitergabe, der Sicherung der Verfügbarkeit und
                    ihrer Trennung. Des Weiteren haben wir Verfahren
                    eingerichtet, die eine Wahrnehmung von Betroffenenrechten,
                    die Löschung von Daten und Reaktionen auf die Gefährdung der
                    Daten gewährleisten. Ferner berücksichtigen wir den Schutz
                    personenbezogener Daten bereits bei der Entwicklung bzw.
                    Auswahl von Hardware, Software sowie Verfahren entsprechend
                    dem Prinzip des Datenschutzes, durch Technikgestaltung und
                    durch datenschutzfreundliche Voreinstellungen.
                </p>
                <p>
                    Sicherung von Online-Verbindungen durch
                    TLS-/SSL-Verschlüsselungstechnologie (HTTPS): Um die Daten
                    der Nutzer, die über unsere Online-Dienste übertragen
                    werden, vor unerlaubten Zugriffen zu schützen, setzen wir
                    auf die TLS-/SSL-Verschlüsselungstechnologie. Secure Sockets
                    Layer (SSL) und Transport Layer Security (TLS) sind die
                    Eckpfeiler der sicheren Datenübertragung im Internet. Diese
                    Technologien verschlüsseln die Informationen, die zwischen
                    der Website oder App und dem Browser des Nutzers (oder
                    zwischen zwei Servern) übertragen werden, wodurch die Daten
                    vor unbefugtem Zugriff geschützt sind. TLS, als die
                    weiterentwickelte und sicherere Version von SSL,
                    gewährleistet, dass alle Datenübertragungen den höchsten
                    Sicherheitsstandards entsprechen. Wenn eine Website durch
                    ein SSL-/TLS-Zertifikat gesichert ist, wird dies durch die
                    Anzeige von HTTPS in der URL signalisiert. Dies dient als
                    ein Indikator für die Nutzer, dass ihre Daten sicher und
                    verschlüsselt übertragen werden.
                </p>
                <h2 id="m12">
                    Allgemeine Informationen zur Datenspeicherung und Löschung
                </h2>
                <p>
                    Wir löschen personenbezogene Daten, die wir verarbeiten,
                    gemäß den gesetzlichen Bestimmungen, sobald die
                    zugrundeliegenden Einwilligungen widerrufen werden oder
                    keine weiteren rechtlichen Grundlagen für die Verarbeitung
                    bestehen. Dies betrifft Fälle, in denen der ursprüngliche
                    Verarbeitungszweck entfällt oder die Daten nicht mehr
                    benötigt werden. Ausnahmen von dieser Regelung bestehen,
                    wenn gesetzliche Pflichten oder besondere Interessen eine
                    längere Aufbewahrung oder Archivierung der Daten erfordern.
                </p>
                <p>
                    Insbesondere müssen Daten, die aus handels- oder
                    steuerrechtlichen Gründen aufbewahrt werden müssen oder
                    deren Speicherung notwendig ist zur Rechtsverfolgung oder
                    zum Schutz der Rechte anderer natürlicher oder juristischer
                    Personen, entsprechend archiviert werden.
                </p>
                <p>
                    Unsere Datenschutzhinweise enthalten zusätzliche
                    Informationen zur Aufbewahrung und Löschung von Daten, die
                    speziell für bestimmte Verarbeitungsprozesse gelten.
                </p>
                <p>
                    Bei mehreren Angaben zur Aufbewahrungsdauer oder
                    Löschungsfristen eines Datums, ist stets die längste Frist
                    maßgeblich.
                </p>
                <p>
                    Beginnt eine Frist nicht ausdrücklich zu einem bestimmten
                    Datum und beträgt sie mindestens ein Jahr, so startet sie
                    automatisch am Ende des Kalenderjahres, in dem das
                    fristauslösende Ereignis eingetreten ist. Im Fall laufender
                    Vertragsverhältnisse, in deren Rahmen Daten gespeichert
                    werden, ist das fristauslösende Ereignis der Zeitpunkt des
                    Wirksamwerdens der Kündigung oder sonstige Beendigung des
                    Rechtsverhältnisses.
                </p>
                <p>
                    Daten, die nicht mehr für den ursprünglich vorgesehenen
                    Zweck, sondern aufgrund gesetzlicher Vorgaben oder anderer
                    Gründe aufbewahrt werden, verarbeiten wir ausschließlich zu
                    den Gründen, die ihre Aufbewahrung rechtfertigen.
                </p>
                <p>
                    <strong>
                        Weitere Hinweise zu Verarbeitungsprozessen, Verfahren
                        und Diensten:
                    </strong>
                </p>
                <ul class="m-elements">
                    <li>
                        <strong>Aufbewahrung und Löschung von Daten: </strong>
                        Die folgenden allgemeinen Fristen gelten für die
                        Aufbewahrung und Archivierung nach deutschem Recht:{" "}
                        <ul>
                            <li>
                                10 Jahre - Aufbewahrungsfrist für Bücher und
                                Aufzeichnungen, Jahresabschlüsse, Inventare,
                                Lageberichte, Eröffnungsbilanz sowie die zu
                                ihrem Verständnis erforderlichen
                                Arbeitsanweisungen und sonstigen
                                Organisationsunterlagen, Buchungsbelege und
                                Rechnungen (§ 147 Abs. 3 i. V. m. Abs. 1 Nr. 1,
                                4 und 4a AO, § 14b Abs. 1 UStG, § 257 Abs. 1 Nr.
                                1 u. 4, Abs. 4 HGB).
                            </li>
                            <li>
                                6 Jahre - Übrige Geschäftsunterlagen: empfangene
                                Handels- oder Geschäftsbriefe, Wiedergaben der
                                abgesandten Handels- oder Geschäftsbriefe,
                                sonstige Unterlagen, soweit sie für die
                                Besteuerung von Bedeutung sind, z. B.
                                Stundenlohnzettel, Betriebsabrechnungsbögen,
                                Kalkulationsunterlagen, Preisauszeichnungen,
                                aber auch Lohnabrechnungsunterlagen, soweit sie
                                nicht bereits Buchungsbelege sind und
                                Kassenstreifen (§ 147 Abs. 3 i. V. m. Abs. 1 Nr.
                                2, 3, 5 AO, § 257 Abs. 1 Nr. 2 u. 3, Abs. 4
                                HGB).
                            </li>
                            <li>
                                3 Jahre - Daten, die erforderlich sind, um
                                potenzielle Gewährleistungs- und
                                Schadensersatzansprüche oder ähnliche
                                vertragliche Ansprüche und Rechte zu
                                berücksichtigen sowie damit verbundene Anfragen
                                zu bearbeiten, basierend auf früheren
                                Geschäftserfahrungen und üblichen
                                Branchenpraktiken, werden für die Dauer der
                                regulären gesetzlichen Verjährungsfrist von drei
                                Jahren gespeichert (§§ 195, 199 BGB).
                            </li>{" "}
                        </ul>
                    </li>
                </ul>
                <h2 id="m10">Rechte der betroffenen Personen</h2>
                <p>
                    Rechte der betroffenen Personen aus der DSGVO: Ihnen stehen
                    als Betroffene nach der DSGVO verschiedene Rechte zu, die
                    sich insbesondere aus Art. 15 bis 21 DSGVO ergeben:
                </p>
                <ul>
                    <li>
                        <strong>
                            Widerspruchsrecht: Sie haben das Recht, aus Gründen,
                            die sich aus Ihrer besonderen Situation ergeben,
                            jederzeit gegen die Verarbeitung der Sie
                            betreffenden personenbezogenen Daten, die aufgrund
                            von Art. 6 Abs. 1 lit. e oder f DSGVO erfolgt,
                            Widerspruch einzulegen; dies gilt auch für ein auf
                            diese Bestimmungen gestütztes Profiling. Werden die
                            Sie betreffenden personenbezogenen Daten
                            verarbeitet, um Direktwerbung zu betreiben, haben
                            Sie das Recht, jederzeit Widerspruch gegen die
                            Verarbeitung der Sie betreffenden personenbezogenen
                            Daten zum Zwecke derartiger Werbung einzulegen; dies
                            gilt auch für das Profiling, soweit es mit solcher
                            Direktwerbung in Verbindung steht.
                        </strong>
                    </li>
                    <li>
                        <strong>Widerrufsrecht bei Einwilligungen:</strong> Sie
                        haben das Recht, erteilte Einwilligungen jederzeit zu
                        widerrufen.
                    </li>
                    <li>
                        <strong>Auskunftsrecht:</strong> Sie haben das Recht,
                        eine Bestätigung darüber zu verlangen, ob betreffende
                        Daten verarbeitet werden und auf Auskunft über diese
                        Daten sowie auf weitere Informationen und Kopie der
                        Daten entsprechend den gesetzlichen Vorgaben.
                    </li>
                    <li>
                        <strong>Recht auf Berichtigung:</strong> Sie haben
                        entsprechend den gesetzlichen Vorgaben das Recht, die
                        Vervollständigung der Sie betreffenden Daten oder die
                        Berichtigung der Sie betreffenden unrichtigen Daten zu
                        verlangen.
                    </li>
                    <li>
                        <strong>
                            Recht auf Löschung und Einschränkung der
                            Verarbeitung:
                        </strong>{" "}
                        Sie haben nach Maßgabe der gesetzlichen Vorgaben das
                        Recht, zu verlangen, dass Sie betreffende Daten
                        unverzüglich gelöscht werden, bzw. alternativ nach
                        Maßgabe der gesetzlichen Vorgaben eine Einschränkung der
                        Verarbeitung der Daten zu verlangen.
                    </li>
                    <li>
                        <strong>Recht auf Datenübertragbarkeit:</strong> Sie
                        haben das Recht, Sie betreffende Daten, die Sie uns
                        bereitgestellt haben, nach Maßgabe der gesetzlichen
                        Vorgaben in einem strukturierten, gängigen und
                        maschinenlesbaren Format zu erhalten oder deren
                        Übermittlung an einen anderen Verantwortlichen zu
                        fordern.
                    </li>
                    <li>
                        <strong>Beschwerde bei Aufsichtsbehörde:</strong> Sie
                        haben unbeschadet eines anderweitigen
                        verwaltungsrechtlichen oder gerichtlichen Rechtsbehelfs
                        das Recht auf Beschwerde bei einer Aufsichtsbehörde,
                        insbesondere in dem Mitgliedstaat ihres gewöhnlichen
                        Aufenthaltsorts, ihres Arbeitsplatzes oder des Orts des
                        mutmaßlichen Verstoßes, wenn Sie der Ansicht sind, dass
                        die Verarbeitung der Sie betreffenden personenbezogenen
                        Daten gegen die Vorgaben der DSGVO verstößt.
                    </li>
                </ul>
                <h2 id="m225">
                    Bereitstellung des Onlineangebots und Webhosting
                </h2>
                <p>
                    Wir verarbeiten die Daten der Nutzer, um ihnen unsere
                    Online-Dienste zur Verfügung stellen zu können. Zu diesem
                    Zweck verarbeiten wir die IP-Adresse des Nutzers, die
                    notwendig ist, um die Inhalte und Funktionen unserer
                    Online-Dienste an den Browser oder das Endgerät der Nutzer
                    zu übermitteln.
                </p>
                <ul class="m-elements">
                    <li>
                        <strong>Verarbeitete Datenarten:</strong> Nutzungsdaten
                        (z. B. Seitenaufrufe und Verweildauer, Klickpfade,
                        Nutzungsintensität und -frequenz, verwendete Gerätetypen
                        und Betriebssysteme, Interaktionen mit Inhalten und
                        Funktionen); Meta-, Kommunikations- und Verfahrensdaten
                        (z. B. IP-Adressen, Zeitangaben, Identifikationsnummern,
                        beteiligte Personen). Protokolldaten (z. B. Logfiles
                        betreffend Logins oder den Abruf von Daten oder
                        Zugriffszeiten.).
                    </li>
                    <li>
                        <strong>Betroffene Personen:</strong> Nutzer (z. B.
                        Webseitenbesucher, Nutzer von Onlinediensten).
                    </li>
                    <li>
                        <strong>Zwecke der Verarbeitung:</strong> Bereitstellung
                        unseres Onlineangebotes und Nutzerfreundlichkeit;
                        Informationstechnische Infrastruktur (Betrieb und
                        Bereitstellung von Informationssystemen und technischen
                        Geräten (Computer, Server etc.).). Sicherheitsmaßnahmen.
                    </li>
                    <li>
                        <strong>Aufbewahrung und Löschung:</strong> Löschung
                        entsprechend Angaben im Abschnitt "Allgemeine
                        Informationen zur Datenspeicherung und Löschung".
                    </li>
                    <li class="">
                        <strong>Rechtsgrundlagen:</strong> Berechtigte
                        Interessen (Art. 6 Abs. 1 S. 1 lit. f) DSGVO).
                    </li>
                </ul>
                <p>
                    <strong>
                        Weitere Hinweise zu Verarbeitungsprozessen, Verfahren
                        und Diensten:
                    </strong>
                </p>
                <ul class="m-elements">
                    <li>
                        <strong>
                            Bereitstellung Onlineangebot auf gemietetem
                            Speicherplatz:{" "}
                        </strong>
                        Für die Bereitstellung unseres Onlineangebotes nutzen
                        wir Speicherplatz, Rechenkapazität und Software, die wir
                        von einem entsprechenden Serveranbieter (auch
                        "Webhoster" genannt) mieten oder anderweitig beziehen;{" "}
                        <span class="">
                            <strong>Rechtsgrundlagen:</strong> Berechtigte
                            Interessen (Art. 6 Abs. 1 S. 1 lit. f) DSGVO).
                        </span>
                    </li>
                    <li>
                        <strong>
                            Erhebung von Zugriffsdaten und Logfiles:{" "}
                        </strong>
                        Der Zugriff auf unser Onlineangebot wird in Form von
                        sogenannten "Server-Logfiles" protokolliert. Zu den
                        Serverlogfiles können die Adresse und der Name der
                        abgerufenen Webseiten und Dateien, Datum und Uhrzeit des
                        Abrufs, übertragene Datenmengen, Meldung über
                        erfolgreichen Abruf, Browsertyp nebst Version, das
                        Betriebssystem des Nutzers, Referrer URL (die zuvor
                        besuchte Seite) und im Regelfall IP-Adressen und der
                        anfragende Provider gehören. Die Serverlogfiles können
                        zum einen zu Sicherheitszwecken eingesetzt werden, z. B.
                        um eine Überlastung der Server zu vermeiden
                        (insbesondere im Fall von missbräuchlichen Angriffen,
                        sogenannten DDoS-Attacken), und zum anderen, um die
                        Auslastung der Server und ihre Stabilität
                        sicherzustellen;{" "}
                        <span class="">
                            <strong>Rechtsgrundlagen:</strong> Berechtigte
                            Interessen (Art. 6 Abs. 1 S. 1 lit. f) DSGVO).{" "}
                        </span>
                        <strong>Löschung von Daten:</strong>{" "}
                        Logfile-Informationen werden für die Dauer von maximal
                        30 Tagen gespeichert und danach gelöscht oder
                        anonymisiert. Daten, deren weitere Aufbewahrung zu
                        Beweiszwecken erforderlich ist, sind bis zur endgültigen
                        Klärung des jeweiligen Vorfalls von der Löschung
                        ausgenommen.
                    </li>
                    <li>
                        <strong>Hetzner: </strong>Leistungen auf dem Gebiet der
                        Bereitstellung von informationstechnischer Infrastruktur
                        und verbundenen Dienstleistungen (z. B. Speicherplatz
                        und/oder Rechenkapazitäten);{" "}
                        <strong>Dienstanbieter:</strong> Hetzner Online GmbH,
                        Industriestr. 25, 91710 Gunzenhausen, Deutschland;{" "}
                        <span class="">
                            <strong>Rechtsgrundlagen:</strong> Berechtigte
                            Interessen (Art. 6 Abs. 1 S. 1 lit. f) DSGVO);{" "}
                        </span>
                        <strong>Website:</strong>{" "}
                        <a href="https://www.hetzner.com" target="_blank" rel="noreferrer">
                            https://www.hetzner.com
                        </a>
                        ; <strong>Datenschutzerklärung:</strong>{" "}
                        <a
                            href="https://www.hetzner.com/de/rechtliches/datenschutz"
                            target="_blank" rel="noreferrer"
                        >
                            https://www.hetzner.com/de/rechtliches/datenschutz
                        </a>
                        . <strong>Auftragsverarbeitungsvertrag:</strong>{" "}
                        <a
                            href="https://docs.hetzner.com/de/general/general-terms-and-conditions/data-privacy-faq/"
                            target="_blank" rel="noreferrer"
                        >
                            https://docs.hetzner.com/de/general/general-terms-and-conditions/data-privacy-faq/
                        </a>
                        .
                    </li>
                </ul>
                <h2 id="m182">Kontakt- und Anfrageverwaltung</h2>
                <p>
                    Bei der Kontaktaufnahme mit uns (z. B. per Post,
                    Kontaktformular, E-Mail, Telefon oder via soziale Medien)
                    sowie im Rahmen bestehender Nutzer- und Geschäftsbeziehungen
                    werden die Angaben der anfragenden Personen verarbeitet,
                    soweit dies zur Beantwortung der Kontaktanfragen und
                    etwaiger angefragter Maßnahmen erforderlich ist.
                </p>
                <ul class="m-elements">
                    <li>
                        <strong>Verarbeitete Datenarten:</strong> Bestandsdaten
                        (z. B. der vollständige Name, Wohnadresse,
                        Kontaktinformationen, Kundennummer, etc.); Kontaktdaten
                        (z. B. Post- und E-Mail-Adressen oder Telefonnummern);
                        Inhaltsdaten (z. B. textliche oder bildliche Nachrichten
                        und Beiträge sowie die sie betreffenden Informationen,
                        wie z. B. Angaben zur Autorenschaft oder Zeitpunkt der
                        Erstellung); Nutzungsdaten (z. B. Seitenaufrufe und
                        Verweildauer, Klickpfade, Nutzungsintensität und
                        -frequenz, verwendete Gerätetypen und Betriebssysteme,
                        Interaktionen mit Inhalten und Funktionen). Meta-,
                        Kommunikations- und Verfahrensdaten (z. B. IP-Adressen,
                        Zeitangaben, Identifikationsnummern, beteiligte
                        Personen).
                    </li>
                    <li>
                        <strong>Betroffene Personen:</strong>{" "}
                        Kommunikationspartner.
                    </li>
                    <li>
                        <strong>Zwecke der Verarbeitung:</strong> Kommunikation;
                        Organisations- und Verwaltungsverfahren; Feedback (z. B.
                        Sammeln von Feedback via Online-Formular).
                        Bereitstellung unseres Onlineangebotes und
                        Nutzerfreundlichkeit.
                    </li>
                    <li>
                        <strong>Aufbewahrung und Löschung:</strong> Löschung
                        entsprechend Angaben im Abschnitt "Allgemeine
                        Informationen zur Datenspeicherung und Löschung".
                    </li>
                    <li class="">
                        <strong>Rechtsgrundlagen:</strong> Berechtigte
                        Interessen (Art. 6 Abs. 1 S. 1 lit. f) DSGVO).
                        Vertragserfüllung und vorvertragliche Anfragen (Art. 6
                        Abs. 1 S. 1 lit. b) DSGVO).
                    </li>
                </ul>
                <p>
                    <strong>
                        Weitere Hinweise zu Verarbeitungsprozessen, Verfahren
                        und Diensten:
                    </strong>
                </p>
                <ul class="m-elements">
                    <li>
                        <strong>Kontaktformular: </strong>Bei Kontaktaufnahme
                        über unser Kontaktformular, per E-Mail oder anderen
                        Kommunikationswegen, verarbeiten wir die uns
                        übermittelten personenbezogenen Daten zur Beantwortung
                        und Bearbeitung des jeweiligen Anliegens. Dies umfasst
                        in der Regel Angaben wie Name, Kontaktinformationen und
                        gegebenenfalls weitere Informationen, die uns mitgeteilt
                        werden und zur angemessenen Bearbeitung erforderlich
                        sind. Wir nutzen diese Daten ausschließlich für den
                        angegebenen Zweck der Kontaktaufnahme und Kommunikation;{" "}
                        <span class="">
                            <strong>Rechtsgrundlagen:</strong> Vertragserfüllung
                            und vorvertragliche Anfragen (Art. 6 Abs. 1 S. 1
                            lit. b) DSGVO), Berechtigte Interessen (Art. 6 Abs.
                            1 S. 1 lit. f) DSGVO).
                        </span>
                    </li>
                </ul>
                <h2 id="mReservierung">Reservierungen, Bestellungen und Veranstaltungsanfragen</h2>
                <p>
                    Wenn Sie über unsere Website einen Tisch reservieren, Speisen zum Abholen oder Liefern bestellen
                    oder eine Feier bzw. ein Catering anfragen, verarbeiten wir die Angaben aus dem jeweiligen Formular,
                    um Ihre Reservierung, Bestellung oder Anfrage zu bearbeiten und mit Ihnen Kontakt aufzunehmen. Sie
                    erhalten dazu in der Regel eine Bestätigung per E-Mail.
                </p>
                <ul className="m-elements">
                    <li>
                        <strong>Verarbeitete Datenarten:</strong> Name, Telefonnummer, E-Mail-Adresse; Datum, Uhrzeit
                        und Personenzahl; Anlass und Nachricht; bei Bestellungen die bestellten Speisen und bei
                        Lieferung die Lieferadresse; technische Angaben wie IP-Adresse und Zeitpunkt der Anfrage zum
                        Schutz vor Missbrauch.
                    </li>
                    <li>
                        <strong>Betroffene Personen:</strong> Gäste, Kunden und Interessenten.
                    </li>
                    <li>
                        <strong>Zwecke der Verarbeitung:</strong> Durchführung von Reservierungen, Bestellungen und
                        Veranstaltungen; Kommunikation; Schutz vor Missbrauch.
                    </li>
                    <li>
                        <strong>Aufbewahrung und Löschung:</strong> Löschung entsprechend Angaben im Abschnitt
                        "Allgemeine Informationen zur Datenspeicherung und Löschung"; Bestelldaten bewahren wir im
                        Rahmen der gesetzlichen Aufbewahrungspflichten auf.
                    </li>
                    <li>
                        <strong>Rechtsgrundlagen:</strong> Vertragserfüllung und vorvertragliche Anfragen (Art. 6 Abs.
                        1 S. 1 lit. b) DSGVO); Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f) DSGVO);
                        Rechtliche Verpflichtung (Art. 6 Abs. 1 S. 1 lit. c) DSGVO).
                    </li>
                </ul>
                <h2 id="mTurnstile">Schutz vor Missbrauch (Cloudflare Turnstile)</h2>
                <p>
                    Um unsere Formulare (Reservierung, Kontakt, Veranstaltungsanfrage) vor automatisierten Anfragen
                    und Spam zu schützen, setzen wir den Dienst Turnstile der Cloudflare, Inc., 101 Townsend St, San
                    Francisco, CA 94107, USA, ein. Beim Aufruf eines Formulars wird ein Skript von Cloudflare geladen,
                    das prüft, ob die Anfrage von einem Menschen stammt. Dabei werden insbesondere Ihre IP-Adresse
                    sowie Angaben zu Browser, Betriebssystem und Ihrer Interaktion mit der Seite an Cloudflare
                    übermittelt.
                </p>
                <ul className="m-elements">
                    <li>
                        <strong>Verarbeitete Datenarten:</strong> Nutzungsdaten; Meta-, Kommunikations- und
                        Verfahrensdaten (z. B. IP-Adressen, Zeitangaben, Geräte- und Browserinformationen).
                    </li>
                    <li>
                        <strong>Zwecke der Verarbeitung:</strong> Schutz vor Missbrauch, Spam und automatisierten
                        Anfragen; Sicherheitsmaßnahmen.
                    </li>
                    <li>
                        <strong>Rechtsgrundlagen:</strong> Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f)
                        DSGVO).
                    </li>
                    <li>
                        <strong>Drittlandübermittlung:</strong> Cloudflare ist unter dem EU-US Data Privacy Framework
                        zertifiziert; die Übermittlung in die USA erfolgt auf Grundlage des
                        Angemessenheitsbeschlusses der EU-Kommission (Art. 45 DSGVO).
                    </li>
                    <li>
                        <strong>Datenschutzerklärung:</strong>{" "}
                        <a href="https://www.cloudflare.com/privacypolicy/" target="_blank" rel="noreferrer">
                            https://www.cloudflare.com/privacypolicy/
                        </a>
                        ; Hinweise zu Turnstile:{" "}
                        <a href="https://www.cloudflare.com/turnstile-privacy-policy/" target="_blank" rel="noreferrer">
                            https://www.cloudflare.com/turnstile-privacy-policy/
                        </a>
                        .
                    </li>
                </ul>
                <h2 id="mKarte">Kartendarstellung (OpenStreetMap)</h2>
                <p>
                    Auf unserer Kontaktseite können Sie eine Karte unseres Standorts anzeigen lassen. Die Karte wird
                    erst geladen, wenn Sie auf „Karte laden“ klicken. Erst dann werden Kartendaten von Servern der
                    OpenStreetMap Foundation (OSMF), St John’s Innovation Centre, Cowley Road, Cambridge, CB4 0WS,
                    Großbritannien, abgerufen und dabei Ihre IP-Adresse sowie Angaben zu Ihrem Browser übermittelt.
                </p>
                <ul className="m-elements">
                    <li>
                        <strong>Verarbeitete Datenarten:</strong> Nutzungsdaten; Meta-, Kommunikations- und
                        Verfahrensdaten (z. B. IP-Adressen, Zeitangaben).
                    </li>
                    <li>
                        <strong>Zwecke der Verarbeitung:</strong> Darstellung einer Karte zur Anfahrt.
                    </li>
                    <li>
                        <strong>Rechtsgrundlagen:</strong> Einwilligung (Art. 6 Abs. 1 S. 1 lit. a) DSGVO) durch
                        den Klick auf „Karte laden“.
                    </li>
                    <li>
                        <strong>Drittlandübermittlung:</strong> Für Großbritannien besteht ein
                        Angemessenheitsbeschluss der EU-Kommission (Art. 45 DSGVO).
                    </li>
                    <li>
                        <strong>Datenschutzerklärung:</strong>{" "}
                        <a href="https://osmfoundation.org/wiki/Privacy_Policy" target="_blank" rel="noreferrer">
                            https://osmfoundation.org/wiki/Privacy_Policy
                        </a>
                        .
                    </li>
                </ul>
                <h2 id="mLinks">Links zu externen Angeboten</h2>
                <p>
                    Unsere Website enthält Links zu Google Maps (Routenplanung), Instagram und Facebook. Diese Angebote
                    sind nicht eingebettet; beim bloßen Besuch unserer Website werden keine Daten an diese Anbieter
                    übermittelt. Erst wenn Sie einen solchen Link anklicken, gelangen Sie auf die Seite des
                    jeweiligen Anbieters, für die dessen eigene Datenschutzbestimmungen gelten.
                </p>
                <p class="seal">
                    <a
                        href="https://datenschutz-generator.de/"
                        title="Rechtstext von Dr. Schwenke - für weitere Informationen bitte anklicken."
                        target="_blank"
                        rel="noopener noreferrer nofollow"
                    >
                        Erstellt mit kostenlosem Datenschutz-Generator.de von
                        Dr. Thomas Schwenke
                    </a>
                </p>
            </div>
            </section>
        </>
    );
};

export default Datenschutz;
